
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.167 12.833c-.436 0-.808-.155-1.118-.465a1.525 1.525 0 01-.466-1.118v-9.5c0-.435.156-.808.466-1.118.31-.31.682-.465 1.118-.465h9.5c.435 0 .808.155 1.118.465.31.31.465.683.465 1.118v3.563l3.167-3.167v8.708L13.25 7.688v3.562c0 .435-.155.808-.465 1.118-.31.31-.683.465-1.118.465h-9.5z"}})])
          )
        }
      }
    